import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';

import { HomePage } from '../home/home';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { SmartAudio } from '../../providers/smart-audio';
import { UserdataModel } from '../../providers/userdata-model';
import { DataExchanger } from '../../providers/data-exchanger';

@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class SettingsPage {
  language: string;
  settingsChanged:boolean;

  constructor(public smartAudio: SmartAudio, public dataExchanger:DataExchanger, public userdataModel:UserdataModel, public rubedoSideMenu: MenuController, public functions: Functions, public translate: TranslateService, public navCtrl: NavController) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(true, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
    
    this.language = '';
    this.settingsChanged=false;
  }

  goToMainMenu(){
    this.navCtrl.setRoot(HomePage, {});
  }

  /* --------- LIFECYCLE --------- */
  ionViewWillLeave(){
    //before the page leaves the viewport
    this.functions.setLanguage();
    if (this.settingsChanged) {
      this.dataExchanger.storeUserGamedataOnServer(true);
      console.log("Setting changed... saving on server");
    }
    this.settingsChanged=false;
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(true);
    this.functions.getLanguage();
    this.settingsChanged=false;
  }  
  
  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }

  changeSetting(settingType,value){
    this.settingsChanged=true;

    // Set settings in userdata is done here for in functions was not possibile due to circular reference problem
    switch (settingType) {
      case "language":
        this.userdataModel.setSettingsCurrentLanguage(this.functions.language);
        this.functions.setLanguage();
      break;

      case "soundEffect":
        this.userdataModel.setSettingsCurrentSoundEffectStatus(this.smartAudio.soundEffectIsActive);
        this.functions.setSoundEffectIsActive();
      break;

      case "musicVolume":
        this.userdataModel.setSettingsCurrentMusicVolume(this.smartAudio.volume);
        this.smartAudio.changeVolumeApp();
        this.functions.setVolume();
      break;

      case "catChosen":
      this.userdataModel.setSettingsCurrentCatChosen(this.functions.catChosen);
      this.functions.setCatChosen();
      break;

      default:
        break;
    }
  }
  /* --------- END LIFECYCLE --------- */
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts